import gql from 'graphql-tag';

export default gql`
  fragment receptionNgReasonFragment on ReceptionNgReason {
    id
    projectId
    reason
  }
`;
